module.exports = fox._r("images/promo/tutorial/01.png", __webpack_public_path__ + "_/common/images/promo/tutorial/01.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/01.png
// module id = 650
// module chunks = 2